module.exports = __webpack_public_path__ + "static/assets/aaaca99fe24710fd0e6bfc5577b029c1.png";